"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// this method accepts an array of variants that could contain duplicates
// and returns a cart add-formatted array with proper quantities
var groupVariantsForCartAdd = function (variants, properties) {
    var uniqueIds = Array.from(new Set(variants.map(function (variant) { return variant.id; })));
    var grouped = uniqueIds.reduce(function (arr, id) {
        var quantity = variants.filter(function (v) { return v.id === id; }).length;
        var variant = variants.find(function (v) { return v.id === id; });
        var compareAtPrice = (variant === null || variant === void 0 ? void 0 : variant.compare_at_price) || (variant === null || variant === void 0 ? void 0 : variant.price);
        // make sure compareAtPrice is in dollars for consistent formatting/sum calculation
        var adjustedCompareAtPrice = typeof compareAtPrice === 'string' ? Number(compareAtPrice) * 100 : Number(compareAtPrice);
        var newProperties = __assign(__assign({}, properties), { compare_at_price: adjustedCompareAtPrice });
        arr.push({ createItemParams: [id, { properties: newProperties, quantity: quantity }], variant: variant });
        return arr;
    }, []);
    return grouped;
};
exports.default = groupVariantsForCartAdd;
